import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { AppEvent } from "@faire/retailer-visitor-shared/packages/core/services/AppEvents";
import { AddToCartVariants } from "@faire/retailer-visitor-shared/stores/domain/CartStore/triggerAddToCartEvent";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
export var IUserAndRetailer;
(function(IUserAndRetailer) {
    IUserAndRetailer.build = function(partial) {
        return {
            user: IUser.build(partial === null || partial === void 0 ? void 0 : partial.user),
            retailer: IRetailer.build(partial === null || partial === void 0 ? void 0 : partial.retailer)
        };
    };
})(IUserAndRetailer || (IUserAndRetailer = {}));
export var IAddedCartItem;
(function(IAddedCartItem) {
    IAddedCartItem.build = function(partial) {
        return _object_spread({
            token: "",
            brandToken: "",
            productToken: "",
            productOptionToken: "",
            productOptionType: undefined,
            isOpenSizing: false,
            quantity: 0,
            addedQuantity: 0,
            addedPrice: 0,
            addedTester: false,
            styleGroupName: undefined,
            styleName: undefined,
            totalPriceCents: undefined,
            totalPrice: undefined,
            productName: undefined,
            imageUrl: undefined,
            totalPromoPrice: undefined
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IAddedCartItem || (IAddedCartItem = {}));
export var IAddToCartBrandData;
(function(IAddToCartBrandData) {
    IAddToCartBrandData.build = function(partial) {
        var _partial_minimumOrderAmountCents, _partial_hasCartItemIssues, _partial_brandTotalAmount, _partial_isAboveFirstOrderMinimumThreshold;
        return {
            name: partial === null || partial === void 0 ? void 0 : partial.name,
            token: partial === null || partial === void 0 ? void 0 : partial.token,
            hasEarnedPromo: partial === null || partial === void 0 ? void 0 : partial.hasEarnedPromo,
            brandPromoDescription: partial === null || partial === void 0 ? void 0 : partial.brandPromoDescription,
            minimumOrderAmountCents: (_partial_minimumOrderAmountCents = partial === null || partial === void 0 ? void 0 : partial.minimumOrderAmountCents) !== null && _partial_minimumOrderAmountCents !== void 0 ? _partial_minimumOrderAmountCents : 0,
            hasCartItemIssues: (_partial_hasCartItemIssues = partial === null || partial === void 0 ? void 0 : partial.hasCartItemIssues) !== null && _partial_hasCartItemIssues !== void 0 ? _partial_hasCartItemIssues : false,
            brandTotalAmount: (_partial_brandTotalAmount = partial === null || partial === void 0 ? void 0 : partial.brandTotalAmount) !== null && _partial_brandTotalAmount !== void 0 ? _partial_brandTotalAmount : 0,
            isAboveFirstOrderMinimumThreshold: (_partial_isAboveFirstOrderMinimumThreshold = partial === null || partial === void 0 ? void 0 : partial.isAboveFirstOrderMinimumThreshold) !== null && _partial_isAboveFirstOrderMinimumThreshold !== void 0 ? _partial_isAboveFirstOrderMinimumThreshold : false,
            deltaFromMinimum: partial === null || partial === void 0 ? void 0 : partial.deltaFromMinimum
        };
    };
})(IAddToCartBrandData || (IAddToCartBrandData = {}));
export var IAddToCartEvent;
(function(IAddToCartEvent) {
    IAddToCartEvent.build = function(partial) {
        return _object_spread({
            added: [],
            brandData: IAddToCartBrandData.build(),
            minimumReached: false,
            remaining: IFaireMoney.build(),
            maximumExceeded: false,
            exceeding: IFaireMoney.build(),
            amountAdded: IFaireMoney.build(),
            isAlreadyOverMinimum: false,
            startTime: 0,
            variant: AddToCartVariants.QUICK_ADD_BTN
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IAddToCartEvent || (IAddToCartEvent = {}));
export var SignUp = new AppEvent("RETAILER_SIGN_UP_EVENT");
export var SignUpPersonalInfoNextPressed = new AppEvent("PERSONAL_INFO_NEXT_PRESSED");
export var SignUpStoreDetailNextPressed = new AppEvent("STORE_DETAIL_NEXT_PRESSED");
export var SignUpDescribeStoreNextPressed = new AppEvent("DESCRIBE_STORE_NEXT_PRESSED");
export var OrderSubmitted = new AppEvent("RETAILER_PURCHASE_EVENT");
export var OrderCanceled = new AppEvent("RETAILER_CANCEL_ORDER_EVENT");
export var AddAddress = new AppEvent("RETAILER_ADD_ADDRESS");
export var ChangeShippingAddress = new AppEvent("RETAILER_CHANGE_SHIPPING_ADDRESS");
export var CartUpdatedV2 = new AppEvent("CART_UPDATED_V2");
export var AddToCart = new AppEvent("CART_ITEMS_UPDATED");
export var AddToCartNotificationFinished = new AppEvent("CART_ITEMS_UPDATED_NOTIFICATION_FINISHED");
/**
 * An event fired whenever a notification is to be shown, used to close any currently shown
 * notification (we show only one at a time).
 */ export var NotificationStarting = new AppEvent("NOTIFICATION_STARTING");
export var AddCollectionToCart = new AppEvent("RETAILER_ADD_COLLECTION_TO_CART");
export var InitiateCheckoutBrandCart = new AppEvent("INITIATE_CHECKOUT_BRAND_CART");
export var InitiateCheckoutAllCarts = new AppEvent("INITIATE_CHECKOUT_ALL_CARTS");
export var InitiateCheckoutFlashSale = new AppEvent("INITIATE_CHECKOUT_FLASH_SALE");
export var FlashSaleOrderSubmitted = new AppEvent("FLASH_SALE_ORDER_SUBMITTED");
export var ViewProduct = new AppEvent("VIEW_PRODUCT");
export var ViewBrand = new AppEvent("VIEW_BRAND");
export var InsiderMembershipPurchase = new AppEvent("INSIDER_MEMBERSHIP_PURCHASE");
export var SearchForProduct = new AppEvent("SEARCH_FOR_PRODUCT");
export var PaidInvoicesSuccess = new AppEvent("PAID_INVOICES_SUCCESS");
export var LimitIncreaseApplicationSubmitted = new AppEvent("LIMIT_INCREASE_APPLICATION_SUBMITTED");
export var MakerSubmitApplication = new AppEvent("MAKER_APPLY_EVENT");
export var MakerAdPageApply = new AppEvent("AD_PAGE_APPLY");
export var PageInitialized = new AppEvent("PAGE_INIT");
export var RefusedRedirectToExternalUrl = new AppEvent("REFUSED_REDIRECT_TO_EXTERNAL_URL");
export var BrandBlogContentFormSubmission = new AppEvent("BRAND_BLOG_CONTENT_FORM_SUBMISSION");
export var InsiderMembershipMutated = new AppEvent("INSIDER_MEMBERSHIP_MUTATED");
export var OpenWithFairePageView = new AppEvent("OPEN_WITH_FAIRE_PAGE_VIEW");
export var OpenWithFairePageYesFundingSelected = new AppEvent("OPEN_WITH_FAIRE_PAGE_YES_FUNDING_SELECTED");
export var OpenWithFaireSignUpApplicationView = new AppEvent("OPEN_WITH_FAIRE_SIGN_UP_APPLICATION_VIEW");
export var OpenWithFaireStoreInfoSectionNextPressed = new AppEvent("OPEN_WITH_FAIRE_STORE_INFO_SECTION_NEXT_PRESSED");
export var OpenWithFaireOwnershipSectionNextPressed = new AppEvent("OPEN_WITH_FAIRE_OWNERSHIP_SECTION_NEXT_PRESSED");
export var OpenWithFaireFinancialSectionNextPressed = new AppEvent("OPEN_WITH_FAIRE_FINANCIAL_SECTION_NEXT_PRESSED");
export var OpenWithFaireAdditionalSectionNextPressed = new AppEvent("OPEN_WITH_FAIRE_ADDITIONAL_SECTION_NEXT_PRESSED");
